const VivinoWidget = ({ vivinoId }) => (
  <iframe
    className="w-[200px] h-[60px]"
    srcDoc={`
        <body style="margin: 0">
          <div
            class="vivino-widget vivino-wine-card-widget"
            style="position: absolute"
            data-vivino-widget-type="wine"
            data-vivino-vintage-id="${vivinoId}"
            data-vivino-widget-language="en"
            data-vivino-widget-layout="small_new"
          ></div>

          <script
            src="https://www.vivino.com/external/vivino-widgets.js"
            async
          ></script>
        </body>
    `}
  ></iframe>
);

export default VivinoWidget;
